<template>
	<section :class="$style.root">
		<div :id="refNode" :ref="refNode" :class="$style.editor" />
	</section>
</template>

<script>
import emailSettings from '@/store/emailSettings'
import { options } from '@/utils/editorOptions'
import findReplace from '@/utils/findReplace'
import { onMounted, onUnmounted, ref, watchEffect } from '@vue/composition-api'

export default {
	name: 'Ace',
	props: {
		defaultContent: {
			required: false,
			default: '',
			type: [String, Object],
		},
		focus: {
			required: false,
			type: Boolean,
		},
		mode: {
			required: true,
			type: String,
		},
		refNode: {
			required: true,
			type: String,
		},
		ariaReadonly: {
			default: 'false',
			required: false,
			type: String,
		},
	},
	setup({ ariaReadonly, defaultContent, focus, mode, refNode }, { emit }) {
		const ace = ref(null)
		const editorRef = ref(refNode)
		const { getSubject, getTitle, getLanguage } = emailSettings
		let editor

		ace.value = window.ace

		onMounted(() => {
			editor = ace.value.edit(editorRef.value)

			editor.session.setUseWorker(false)

			editor.setOptions(options)

			editor.session.setMode(`ace/mode/${mode}`)
			focus && editor.focus()

			editor.on('input', () => {
				const content = editor.session.getValue()
				emit('content-change', { mode, content })
			})

			watchEffect(() => {
				if (ariaReadonly === 'true') {
					editor.setReadOnly(true)
				}
				if (defaultContent && defaultContent !== '') {
					editor.session.setValue(defaultContent, -1)
				}

				findReplace({
					editor,
					find: '[lang]',
					replaceWith: getLanguage,
				})

				findReplace({
					editor,
					find: '[subject]',
					replaceWith: getSubject,
				})

				findReplace({
					editor,
					find: '[title]',
					replaceWith: getTitle,
				})
			})
		})

		onUnmounted(() => {
			editor.destroy()
		})

		return { ace }
	},
}
</script>

<style lang="less" module scoped>
.root {
	display: flex;
}

.editor {
	flex: 1;
	margin: 0 auto;
	width: 100%;
}

.root /deep/ div[id] {
	line-height: 1.6;
}

.root /deep/ span[class] {
	font-style: normal !important;
}

.root /deep/ .ace_content,
.root /deep/ .ace_gutter,
.root /deep/ .ace_layer,
.root /deep/ div[class] {
	will-change: auto !important;
}
</style>
